// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"parentheses"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4.1084 5C3.07812 7.11438 2.5 9.48969 2.5 12C2.5 14.5103 3.07812 16.8856 4.1084 19M19.8916 19C20.9219 16.8856 21.5 14.5103 21.5 12C21.5 9.48969 20.9219 7.11438 19.8916 5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-parentheses')
export default class ParenthesesIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'parentheses',
    }
  }
}
